import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServicesService } from '../services/api-services.service';
import { BeneficiaryDetails } from 'src/app/data/models/beneficiaryDetails.model';
import { BeneAddress } from 'src/app/data/models/beneficiaryDetails.model';
import { ReferenceLibrary } from 'src/app/data/models/referenceLibrary.model';
import moment from 'moment';

@Component({
  selector: 'app-display-information',
  templateUrl: './display-information.component.html',
  styleUrls: ['./display-information.component.scss']
})
export class DisplayInformationComponent implements OnInit {

  @Input() beneficiaryIdInput;
  educationDetailsList: any = [];
  beneficiaryData: BeneficiaryDetails;
  datesStoredArrayForDisplay = [
    { dob: '' },
    { issueDate: '' },
    { expiryDate: '' }
  ];
  addressTypeList: ReferenceLibrary[];
  showAliasName: boolean = false;
  listStatesCurrent = [];

  constructor(private activatedRoute: ActivatedRoute,
    private apiService: ApiServicesService,) {

  }

  getBeneficiaryDetails() {
    this.apiService.getBeneficiaryDetails(this.beneficiaryIdInput, 'self').subscribe((beneficiary: BeneficiaryDetails) => {
      this.beneficiaryData = beneficiary;
      let orderedArr: BeneAddress[] = [];
      if (this.beneficiaryData.address && this.beneficiaryData.address.length > 0) {
        if (this.beneficiaryData.address.find(x => x.type.code === 'CURR')) {
          orderedArr[0] = this.beneficiaryData.address.find(x => x.type.code === 'CURR');
        }
        if (this.beneficiaryData.address.find(x => x.type.code === 'PERM')) {
          orderedArr[1] = this.beneficiaryData.address.find(x => x.type.code === 'PERM');
        }
        if (this.beneficiaryData.address.find(x => x.type.code === 'FORN')) {
          orderedArr[2] = this.beneficiaryData.address.find(x => x.type.code === 'FORN');
        } else {
          orderedArr[2] = {
            id: null,
            addressLine1: null,
            addressLine2: null,
            countryCode: {
              countryCode: null,
              countryName: null,
            },
            stateProvinceCode: null,
            stateProvinceName: null,
            state: null,
            city: null,
            locality: null,
            postCode: null,
            type: {
              id: this.addressTypeList.find(x => x.code === 'FORN') ? this.addressTypeList.find(x => x.code === 'FORN').id : null,
              code: 'FORN',
              name: 'Foreign'
            }
          };
        }
      }
      ///IM-3601
      this.datesStoredArrayForDisplay['dob'] = moment(this.beneficiaryData.dob).toISOString();
      this.datesStoredArrayForDisplay['issueDate'] = this.beneficiaryData.passport[0] ? moment(this.beneficiaryData.passport[0].issueDate).toISOString() : '';
      this.datesStoredArrayForDisplay['expiryDate'] = this.beneficiaryData.passport[0] ? moment(this.beneficiaryData.passport[0].expiryDate).toISOString() : '';

      this.beneficiaryData.address = orderedArr;
      if (this.beneficiaryData && this.beneficiaryData.aliasName && this.beneficiaryData.aliasName.length > 0) {
        this.showAliasName = (this.beneficiaryData.aliasName[0].fName) ? true : false;
      }

      if (!this.beneficiaryData.gender) {
        this.beneficiaryData.gender = {
          id: null,
          name: null
        };
      }
      if (!this.beneficiaryData.countryCode) {
        this.beneficiaryData.countryCode = {
          countryCode: null,
          countryName: null
        };
      }

      if (!(this.beneficiaryData.ctznshipCountryCode && this.beneficiaryData.ctznshipCountryCode.countryCode)) {
        this.beneficiaryData.ctznshipCountryCode = {
          countryCode: null,
          countryName: null
        };
      }

    });
  }

  ngOnInit() {
    if (this.beneficiaryIdInput != '') {      
      this.apiService.getEducationDetails(this.beneficiaryIdInput)
        .subscribe(data => {
          if (data['status'] === 200) {
            this.educationDetailsList = data['data']['education'];
          }
          if (data['status'] === 204) {
            this.educationDetailsList = [];
          }
        });
    }
    this.getBeneficiaryDetails();
  }

  getStateName(stateCode: string, addressType: string) {

  }

}
